/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.alert__date[_ngcontent-%COMP%]{font-weight:900;font-size:.9em;letter-spacing:.02em;color:#fff}.alert__info[_ngcontent-%COMP%]{font-size:.8em;margin-bottom:8px}.alert__date[_ngcontent-%COMP%], .alert__info[_ngcontent-%COMP%]{display:block;text-indent:0}.alert__button--yes[_ngcontent-%COMP%]{margin-right:5px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2lkZW5hdi9hbGVydHMvc2lkZW5hdi1hbGVydHMuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaWRlbmF2L2FsZXJ0cy9zaWRlbmF2LWFsZXJ0cy5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/sidenav/alerts/sidenav-alerts.component.scss.shim.ngstyle.ts